import { render } from "./App.vue?vue&type=template&id=21ace175"
const script = {}

import "./App.vue?vue&type=style&index=0&id=21ace175&lang=scss"

import exportComponent from "/Users/bahramhasanov/_PHP/map_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__